<template>
    <div class="list-rencent-lising-mb standard">
        <div class="title mg-title">
            <div class="desc" v-html="recentListingTitle"></div>
            <div
                class="more"
                v-show="!showRecentListingNoLocation && !soldAvgText"
            >
                <drop-down-nav :nav-list="listingStatus" />
            </div>
        </div>
        <!-- sold price avg -->
        <template v-if="soldAvgText">
            <div class="sub-title" v-html="soldAvgText"></div>
        </template>
        <div v-show="!showRecentListingNoLocation">
            <div class="list_container">
                <listing-table :showLock="showLock" />
            </div>
        </div>
        <div
            class="location_tips_container"
            v-show="showRecentListingNoLocation"
        >
            <img
                class="pic"
                src="//static.chimeroi.com/image/snapshot/v3-img-no-listing@2x.png"
                alt
            />
            <div class="desc">
                {{ $t('md-listing-list.pleaseInputAValid') }}
            </div>
        </div>
        <!-- lock start -->
        <div class="lock-container" v-if="showLock">
            <div class="box">
                <div class="lock-icon">
                    <span class="iconfont icon-circle-lock"></span>
                </div>
                <div class="desc" @click="showRegisterPop">
                    {{ $t('md-listing-list.unlockRecentListings')
                    }}<i class="iconfont icon-chevron_right"></i>
                </div>
            </div>
        </div>
        <!-- lock end -->
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';

import ListingTable from '../list_table/mobile';
import DropDownNav from '../nav/drop-down-nav';

import common from '../../../_mixins/recent-listings/common';
export default {
    name: 'rencent-lising-mb',
    mixins: [common],
    components: {
        'listing-table': ListingTable,
        'drop-down-nav': DropDownNav
    },
    props: {
        recentListingTitle: {
            required: true,
            type: String
        }
    },
    computed: {

        ...mapState({
            "listingStatus": store => store.listingStatus,
            "showRecentListingNoLocation": "showRecentListingNoLocation"
        }),
        
        
    }
};
</script>

<style lang="scss">
.list-rencent-lising-mb.standard{
    font-family: var(--font-normal);
    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        overflow: visible;
        div {
            overflow: visible;
        }
        .desc {
            font-family: var(--mg-title-font);
            font-size: var(--mg-title-size-mobile);
            line-height: var(--mg-title-line-height);
            letter-spacing: var(--mg-title-letter-spacing);
            color: var(--mg-title-color);
            text-transform: uppercase;
            text-align: var(--mg-title-align);
        }
        .more {
            display: flex;
            font-size: 12px;
            color: var(--color-label);
            .listint_status {
                margin-right: 3px;
            }
        }
    }
    .sub-title {
        color: #a0a3af;
        font-size: 12px;
        font-family: var(--font-medium);
        margin-bottom: 20px;
        margin-top: -15px;
        text-align: var(--mg-title-align);
    }
    .location_tips_container {
        width: 100%;
        padding-top: 80px;
        padding-bottom: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .pic {
            width: 220px;
            height: 130px;
        }
        .desc {
            margin-top: 20px;
            font-size: 16px;
            padding: 0 20px;
            text-align: center;
            color: var(--color-holder);
        }
    }
    .lock-container {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: absolute;
        z-index: var(--level-low);
        top: 0;
        left: 0;
        -webkit-backdrop-filter: blur(4px);
        backdrop-filter: blur(4px);
        background-color: rgba(255, 255, 255, 0.85);
        .lock-icon {
            text-align: center;
            .icon-circle-lock {
                color: var(--color-theme);
                font-size: 60px;
            }
        }
        .desc {
            cursor: pointer;
            font-size: 16px;
            font-family: var(--font-bold);
            font-weight: 500;
            margin-top: 40px;
            color: var(--color-theme);
        }
    }
}

</style>
